module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxsiAiQ_a33snTsJhwZvMEaI.woff2";